import { useTranslation } from "react-i18next";
import { Button, Dropdown, Form, Layout, MenuProps, Modal, Popconfirm, Space, Spin, Switch, TableColumnsType, TableProps, Typography, message } from "antd";
import { ChangeEvent, FunctionComponent, KeyboardEvent, useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom";
import { HelpService } from "../../../service/helper.service";
import { CloseOutlined, DeleteOutlined, EditOutlined, EyeOutlined, LoadingOutlined, MoreOutlined, SaveOutlined } from "@ant-design/icons";
import { FormInstance } from "antd/lib";
import { routesConfig } from "../../../config/routes";
import { DataType, validateFieldCreate } from "./constants/data";
import PageHeader from "../../../components/page-header/PageHeader";
import FilterTable from "./components/filter-table/FilterTable";
import FormFilter from "./components/filter-group/FormFilter";
import TableData from "../../../components/table-data/TableData";
import DrawerCustom from "../../../components/drawer/Drawer";
import FormCreateStudent from "./components/form-create-student/FormCreateStudent";
import { get, isEmpty } from "lodash";
import { formatDateV2 } from "../../../utils/converDate";
import "./student-management.scss";
import { addMoocStudent, changeStatusStudent, deleteMoocStudent, downloadStudentTemplateFile, exportExcelMoocStudent, getAddressProvinces, getAllStudentByFilter, getIndustryStudent, getMoocStudentById, importExcelMoocStudent, updateMoocStudent } from "../../../service/category-management/student-management";
import ImportIndustryDBModal from "./components/import-industry-db-modal/ImportIndustryDBModal";
import { getAllEnterpriseUniversityVer2 } from "../../../service/management-participate-platform";
import { getAllIndustryGroup } from "../../../service/course-construct";
import { globalStore } from "../../../stores/stores";
import { Permission } from "../../../layout/sidebar/permission.enum";

type StudentManagementProps = {
  title?: string;
};

const StudentManagement = ({ title }: StudentManagementProps) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const helpService = new HelpService();
  const { personalInfo, reload } = globalStore();
  const permissions = personalInfo?.permissions;
  const [params, setParams] = useSearchParams();
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [isOpenedEdit, setIsOpenedEdit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingForm, setLoadingForm] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isRendering, setIsRendering] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [hasUniversity, setHasUniversity] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [openImportStudentModal, setOpenImportStudentModal] = useState<boolean>(false);
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
  const [editId, setEditId] = useState<number>(0);
  const [dataDetail, setDataDetail] = useState<any>({});
  const [dataStudent, setDataStudent] = useState<any>([]);
  const [dataOptions, setDataOptions] = useState<any>({
    dataUniversity: [],
    dataDepartment: [],
    dataSpecialized: [],
    dataProvince: [],

  });

  const [filterData, setFilterData] = useState<any>({
    keyword: null,
    status: null,
    university: null,
    industry: null,
    createdDateFrom: null,
    createdDateTo: null,
  });

  const studentOptions: MenuProps["items"] = [
    {
      key: "1",
      label: t("Sửa sinh viên", "Sửa sinh viên"),
      icon: <EditOutlined />,
    },
    {
      key: "2",
      label: t("Xóa sinh viên", "Xóa sinh viên"),
      icon: <DeleteOutlined />,
      className: "dropdown-delete",
      danger: true,
    },
  ];

  const dataColumns: TableColumnsType<DataType> = [
    {
      title: t("STT", "STT"),
      dataIndex: "stt",
      key: "stt",
      sorter: true,
      width: 10,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Tên sinh viên", "Tên sinh viên"),
      dataIndex: "name",
      key: "name",
      className:"title-sequence",
      sorter: true,
      width: 40,
      render: (_: any, record) => {
        return (
          <div className="table-student cursor-pointer">
            <div>
              <a
                className="student-name"
                onClick={() =>
                  navigate(
                    `${routesConfig.studentManagementDetail}/${record?.id}`,
                    {
                      state: {
                        mode: "view",
                        record,
                        name: record.name,
                        idEdit: record?.id,
                      },
                    }
                  )
                }
              >
                {record.name}
              </a>
            </div>
          </div>
        );
      },
    },
    {
      title: t("Mã sinh viên", "Mã sinh viên"),
      dataIndex: "code",
      key: "code",
      className:"title-sequence",
      width: 20,
    },
    {
      title: t("Cơ sở đào tạo", "Cơ sở đào tạo"),
      dataIndex: "universityName",
      key: "universityName",
      className:"title-sequence",
      width: 50,
    },
    {
      title: t("Chuyên ngành", "Chuyên ngành"),
      dataIndex:"industryGroupInfo",
      key:"industryGroupInfo",
      className:"title-sequence",
      width: 20,
      render: (_: any, record: any, index: number) => {
        // Kiểm tra nếu có dữ liệu chuyên ngành con (children)
        return record.industryGroupInfo?.children?.map((item: any) => item.name).join(", ");
      },
    },
    {
      title: t("Email", "Email"),
      dataIndex:"email",
      key:"email",
      className:"title-sequence",
      width: 30,
    },
    {
      title: t("Ngày tạo", "Ngày tạo"),
      dataIndex: "createdDate",
      key: "createdDate",
      width: 20,
      render: (_: any, record: any, index: number) => {
        return record.createdDate ? formatDateV2(record.createdDate) : null;
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      dataIndex: "status",
      key: "status",
      render: (_: any, record: { status: boolean; id: number }) => {
        const handleChange = (checked: boolean) => {
          record.status = checked;
        };

        const confirm = (id: number) => {
          changeStatusStudent({
            usedId: id, 
            isActive: record?.status,
          }).then((res) => {
            if (res.status === 200) {
              helpService.successMessage(t("Thay đổi trạng thái thành công!", "Thay đổi trạng thái thành công!"));
              getAllStudent();
            }
          }).catch(err => {
          })
        };

        const cancel = () => {
          helpService.errorMessage(t("Hủy thao tác thành công!", "Hủy thao tác thành công!"));
        };

        return (
          <Popconfirm
            rootClassName="popconfirm-change-status"
            description={t("Xác nhận đổi trạng thái?", "Xác nhận đổi trạng thái?")}
            onConfirm={() => confirm(get(record, 'id'))}
            onCancel={cancel}
            okText={t("Xác nhận", "Xác nhận")}
            cancelText={t("Huỷ", "Huỷ")}
            title="">
            <Switch defaultChecked={record.status}
                    checked={record.status}
                    onChange={handleChange}/>
          </Popconfirm>
        );
      },
      width: 20,
    },
    {
      title: "",
      dataIndex: "action",
      key: "operation",
      render: (_, record) => {
        const location = {
          id: `${record.id}`,
        };

        return (
          <>
            <Space>
              <a
                className="action-table"
                onClick={() =>
                  navigate(
                    `${routesConfig.studentManagementDetail}/${record?.id}`,
                    {
                      state: {
                        mode: "view",
                        record,
                        name: record.name,
                        idEdit: record?.id,
                      },
                    }
                  )
                }
              >
                <EyeOutlined />
              </a>

              <Dropdown
                menu={{
                  items: studentOptions,
                  onClick: ({ key }) => {
                    if (key === "1") {
                      getStudentUpdate(record.id);
                      handleOpenEdit(record.id);
                    }
                    if (key === "2") {
                      Modal.confirm({
                        title: t("Xóa sinh viên", "Xóa sinh viên"),
                        content: t("Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?", "Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?"),
                        onOk: () => deleteStudent(record),
                        centered: true,
                        okText: t("Xác nhận", "Xác nhận"),
                        cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
                        footer: (_, { OkBtn, CancelBtn }) => (
                          <>
                            <CancelBtn />
                            <OkBtn />
                          </>
                        ),
                      });
                    }
                  },
                }}
                placement="bottomRight"
              >
                <Button>
                  <MoreOutlined />
                </Button>
              </Dropdown>
            </Space>
          </>
        );
      },
      fixed: "right",
      width: 20,
    },
  ];

  const listBreadcrumb = [
    {
      title: t("Quản trị danh mục", "Quản trị danh mục"),
    },
  ];

  // Get data student
  const getAllStudent = (data?: any) => {
    setLoading(true);
    const dataReq = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue,
      universityId: dataOptions.dataUniversity?.length === 1 ? dataOptions.dataUniversity?.[0]?.id : filterData.university,
      industryId: filterData.industry,
      status: filterData.status,
      createdFromDate: filterData.createdDateFrom? filterData.createdDateFrom : null,
      createdToDate: filterData.createdDateTo ? filterData.createdDateTo : null,
      sort: isEmpty(fieldSortOrder) || isEmpty(statusOrder) ? ['created_date, desc'] : [`${fieldSortOrder},${statusOrder}`]
    };
    getAllStudentByFilter(dataReq)
      .then((res) => {
        setDataStudent(res.data.data.moocUniversityMemberData);
        setTotalRecords(res.data.data.total);
        setTimeout(() => {
          setLoading(false);
        }, 300);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  // Filter Search
  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const check = !!(permissions?.includes(Permission.isQTCS) || permissions?.includes(Permission.isQTDH) || localStorage.schoolManagement);

  const clearFilter = (form: FormInstance) => {
    const allFields = form.getFieldsValue();
    const fieldsToReset = Object.keys(allFields).filter((key) => key !== "university");
    check ? form.resetFields(fieldsToReset) : form.resetFields();

    setFilterData({
      university: check ? filterData.university : null,
      status: null,
      industry: null,
      createdDateFrom: null,
      createdDateTo: null,
    });
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setParams({ [name]: value });
    setSearchValue(value);
    if (value.length === 0) {
      setSearchValue("");
      setParams();
    }
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      setPageNumber(1);
      getAllStudent();
    }
  };

  const handleSubmitSearch = () => {
    setPageNumber(1);
    getAllStudent();
  };

  const handleFinish = (values: any) => {
    setPageNumber(1);
    setFilterData({
      ...filterData,
      status: values?.status,
      university: values?.university,
      industry: values?.specialized,
      createdDateFrom: values?.time ? (values?.time[0]).add(1, "day").toISOString() : null,
      createdDateTo: values?.time ? (values?.time[1]).add(1, "day").toISOString() : null,
    });
  };

  // Get university
  const getAllUniversity = async () => {
    setLoading(true);
    await getAllEnterpriseUniversityVer2({}).then((res) => {
      const dataEnterpriseUniversity = res.data?.data?.map((item: any) => {
        return ({
          id: item.universityId,
          name: item.name,
          uuid: item.uuid,
        })
      });

      setDataOptions({
        ...dataOptions,
        dataUniversity: dataEnterpriseUniversity,
      });

      setTimeout(() => {
        setLoading(false);
      }, 300);
    })
  }

  // Get student to edit
  const getStudentUpdate = async (id: number) => {
    setLoadingForm(true);
    await getMoocStudentById(id).then((res) => {
      const { data } = res.data;
      setDataDetail(data);
      setTimeout(() => {
        setLoadingForm(false);
      }, 333);
    })
    .catch((err) => {
      setLoadingForm(false);
      console.error(err);
    });
  };

  // Modal create | edit
  const handleOpenCreate = () => {
    setIsOpened(true);
  };

  const handleOpenEdit = (id: number) => {
    setEditId(id);
    setIsOpened(true);
    setIsOpenedEdit(true);
  };

  const handleClose = () => {
    setIsOpened(false);
    setIsOpenedEdit(false);
    form.resetFields();
  };

  const handleCreateAndEdit = () => {
    Modal.confirm({
      title: !isOpenedEdit ? t("Thêm mới sinh viên", "Thêm mới sinh viên") : t("Chỉnh sửa sinh viên", "Chỉnh sửa sinh viên"),
      content: t("Đảm bảo tất cả các thông tin liên quan đã được kiểm tra và cập nhật đầy đủ trước khi lưu", "Đảm bảo tất cả các thông tin liên quan đã được kiểm tra và cập nhật đầy đủ trước khi lưu"),
      onOk: () => form.submit(),
      centered: true,
      okText: t("Xác nhận", "Xác nhận"),
                        cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
      footer: (_, { OkBtn, CancelBtn }) => (
        <>
          <CancelBtn />
          <OkBtn />
        </>
      ),
    });
  }

  const onFinishCreate = async (values: any) => {
    if (Object.keys(values).length > 0) {
      if (isOpenedEdit) {
        const dataPayload = {
          name: values.name.trim(),
          universityId: values.university,
          gender: values.gender,
          code: values.code.trim(),
          provinceCode: values.domicile ? values.domicile : null,
          industryGroupId: values.department,
          industryIds: values.specialized,
          phoneNumber: values.phone.trim(),
          email: values.email.trim(),
          status: values.status,
        };
        setIsSaving(true);
        try {
          await updateMoocStudent(editId, dataPayload).then((res) => {
            const { success } = res.data;
            if (success) {
              message.success(t("Cập nhật sinh viên thành công!", "Cập nhật sinh viên thành công!"));
            } else {
              message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
            }
            handleClose();
            getAllStudent();
          })
        } catch (err) {
          console.error(err);
        } finally {
          setIsSaving(false);
        }
      } else {
        const dataPayload = {
          name: values.name.trim(),
          universityId: values.university,
          gender: values.gender,
          code: values.code.trim(),
          provinceCode: values.domicile ? values.domicile : null,
          industryGroupId: values.department,
          industryIds: values.specialized,
          phoneNumber: values.phone.trim(),
          email: values.email.trim(),
          status: values.status,
        };
        try {
          await addMoocStudent(dataPayload).then((res) => {
            const { success } = res.data;
            if (success) {
              message.success(t("Thêm mới sinh viên thành công!", "Thêm mới sinh viên thành công!"));
            } else {
              message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
            }
            handleClose();
            getAllStudent();
          })
        } catch (err) {
          console.error(err);
        } finally {
          setIsSaving(false);
        }
      }
    }
  };

  // Delete student
  const deleteStudent = async (student: any) => {
    try {
      await deleteMoocStudent(student.id).then((res) => {
        if (res.status === 200) {
          message.success(t("Xóa sinh viên thành công!", "Xóa sinh viên thành công!"));
          getAllStudent();
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  // Import file Excel to add new
  const importExcel = async (file: any) => {
    setLoading(true);
    await importExcelMoocStudent(file).then((res) => {
      if (res.status === 200) {
        message.success(t("Thêm mới sinh viên thành công!", "Thêm mới sinh viên thành công!"));
        setLoading(false);
        setTimeout(() => {
          setLoading(false);
        }, 300);
        getAllStudent();
      }
    }).catch((err) => {{
      setLoading(false);
      console.error(err);
    }})
  }

  // Import IndustryDB
  const handleCloseImportStudentModal = () => {
    setOpenImportStudentModal(false);
  }

  // Export file Excel
  const exportExcel = async () => {
    const dataReq = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue,
      universityId: filterData.university,
      industryId: filterData.industry,
      createdFromDate: filterData.createdDateFrom ? filterData.createdDateFrom : null,
      createdToDate: filterData.createdDateTo ? filterData.createdDateTo : null,
      sort: isEmpty(fieldSortOrder) || isEmpty(statusOrder) ? ['created_date, desc'] : [`${fieldSortOrder},${statusOrder}`],
      status: filterData.status,
    };
    setIsRendering(true);
    try {
      await exportExcelMoocStudent(dataReq).then((res) => {
        const fileData = res.data;

        const blob = new Blob([fileData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);

        downloadLink.download = `${t("Danh sách sinh viên", "Danh sách sinh viên")}.xlsx`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        message.success(t("Tải xuống thành công!", "Tải xuống thành công!"));
        setIsRendering(false);
      })
    } catch (err) {
      setIsRendering(false);
      console.error("Error downloading Excel file:", err);
    }
  }

  // Download file template excel
  const handleDownloadFile = async () => {
    try {
      await downloadStudentTemplateFile().then((res) => {
        const fileData = res.data;

        const blob = new Blob([fileData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);

        downloadLink.download = `${t("Mẫu thêm mới", "Mẫu thêm mới")} ${t("sinh viên", "sinh viên")}.xlsx`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        message.success(t("Tải xuống thành công!", "Tải xuống thành công!"))
      })
    } catch (err) {
      console.error("Error downloading Excel file:", err);
    }
  }

  // Sort
  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
        ? "desc"
        : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  // useEffect
  useEffect(() => {
    if (Object.keys(dataDetail).length > 0) {
      const industryIds = dataDetail.industryGroupInfo?.children.map((item: any) => {
        return(item.id)
      })

      form.setFieldsValue({
        name: dataDetail.name,
        university: dataDetail.universityId,
        code: dataDetail.code,
        department: dataDetail.industryGroupInfo?.id,
        specialized: industryIds,
        gender: dataDetail.gender,
        domicile: dataDetail.provinceCode ? dataDetail.provinceCode : null,
        phone: dataDetail.phoneNumber,
        email: dataDetail.email,
        status: dataDetail.status,
      });
    }
  }, [dataDetail]);

  useEffect(() => {
    if(hasUniversity) {
      getAllStudent();
    }    
  }, [pageNumber, pageSize, filterData, statusOrder, hasUniversity, localStorage.schoolManagement]);

  useEffect(() => {
    if(hasUniversity) {
      getAllUniversity();
    }
  }, [localStorage.schoolManagement]);

  useEffect(() => {
    setLoading(true);
    Promise.all([getAllIndustryGroup(), getIndustryStudent(""), getAllEnterpriseUniversityVer2({}), getAddressProvinces()])
    .then((res) => {
      const dataIndustryGroup = res[0]?.data?.data;
      const dataIndustry = res[1]?.data?.data;
      const dataEnterpriseUniversity = res[2].data?.data?.map((item: any) => {
        return {
          id: item.universityId,
          name: item.name,
          uuid: item.uuid,
        }
      });
      const dataProvinces = res[3].data.data.map((item: any) => {
        return ({
          id : item.code,
          name: item.name,
        })
      });
      
      setDataOptions({
        ...dataOptions,
        dataDepartment: dataIndustryGroup,
        dataSpecialized: dataIndustry,
        dataUniversity: dataEnterpriseUniversity,
        dataProvince: dataProvinces,
      });

      setTimeout(() => {
        setHasUniversity(true);
        setLoading(false);
      }, 300);
    })
  },[reload]);

  return (
    <Layout className="page-header-group">
      <Form.Provider onFormFinish={(name, { values, forms }) => {
          if (name === "createStudent") {
            const { createStudent } = forms;
            const data = createStudent.getFieldsValue(validateFieldCreate);
            onFinishCreate(data);
          }
        }}
      >
        <div className={`page-header-group--layout ${ showFilter ? "open-filter" : "" }`} >
          <div className="table-header--wrapper">
            <div className="table-header--left">
              <PageHeader title={title} listBreadcrumb={listBreadcrumb} />
            </div>
            <FilterTable
              handleOpen={handleOpenCreate}
              searchValue={searchValue}
              handleOpenFilter={handleOpenFilter}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              handleChangeInput={handleChangeInput}
              exportExcel={exportExcel}
              handleDownloadFile={handleDownloadFile}
              importExcel={importExcel}
              isRendering={isRendering}
              setOpenImportStudentModal={setOpenImportStudentModal}
            />
          </div>
          <FormFilter
            clearFilter={clearFilter}
            dataOptions={dataOptions}
            onFinish={handleFinish}
            showFilter={showFilter}
            check={check}
          />
        </div>

        <TableData
          dataTable={dataStudent}
          dataColumns={dataColumns}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          pageSize={pageSize}
          pagination={true}
          scroll={{ x: 1500, y: 600 }}
          totalRecords={totalRecords}
          loadingTable={loading}
          handleTableChangeProps={handleTableChange}
        />

        <DrawerCustom 
          title={isOpenedEdit ? t("Chỉnh sửa sinh viên", "Chỉnh sửa sinh viên") : t("Thêm mới sinh viên", "Thêm mới sinh viên")}
          open={isOpened}
          onClose={handleClose}
          extraNode={
            <Space>
              <Button onClick={handleClose} className="btn btn-outlined">
                <CloseOutlined />
                <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
              </Button>
              <Button className="btn btn-primary" htmlType="submit" onClick={handleCreateAndEdit} disabled={isSaving}>
                {isSaving ? <LoadingOutlined /> : <SaveOutlined />}
                <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
              </Button>
            </Space>
          }
          widthDrawer={690}
        >
          <FormCreateStudent form={form} dataOptions={dataOptions} loadingForm={loadingForm}/>
        </DrawerCustom>
      </Form.Provider>
      <ImportIndustryDBModal openImportStudentModal={openImportStudentModal} handleCloseImportStudentModal={handleCloseImportStudentModal}/>
    </Layout>
  );
};

export default StudentManagement;
